module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.taskId && _vm.$props.userId && _vm.$props.user) ? _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "z-task-time"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "z-task-time__body"
  }, [_c('div', {
    staticClass: "z-task-time__list"
  }, _vm._l((_vm.timeline), function(item, i) {
    return _c('div', {
      staticClass: "z-time__item",
      class: {
        'active': item.active
      }
    }, [(item.user) ? _c('div', {
      staticClass: "z-time__head"
    }, [_c('div', {
      staticClass: "z-time__user"
    }, [_vm._v(_vm._s((item.user.fio) ? item.user.fio : item.user.login))])]) : _vm._e(), _c('div', {
      staticClass: "z-time__top"
    }, [_c('div', {
      staticClass: "z-time__field date",
      class: {
        'active': item.active
      }
    }, [_c('div', {
      staticClass: "z-time-input",
      class: {
        'active': item.active
      }
    }, [_c('datetime', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "id": ('time-date-' + i),
        "name": ('time-date-' + i),
        "input-class": "",
        "type": "date",
        "use12-hour": false,
        "week-start": 1,
        "phrases": {
          ok: 'Ок',
          cancel: 'Отмена'
        },
        "disabled": !item.active
      },
      model: {
        value: (item.date),
        callback: function($$v) {
          _vm.$set(item, "date", $$v)
        },
        expression: "item.date"
      }
    })], 1)]), _c('div', {
      staticClass: "z-time__field time",
      class: {
        'active': item.active
      }
    }, [_c('div', {
      staticClass: "z-time-input",
      class: {
        'active': item.active
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.days),
        expression: "item.days"
      }],
      attrs: {
        "type": "number",
        "disabled": !item.active,
        "min": "0",
        "max": "365",
        "placeholder": "0"
      },
      domProps: {
        "value": (item.days)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "days", $event.target.value)
        }
      }
    }), _c('label', [_vm._v("д")])]), _c('div', {
      staticClass: "z-time-input",
      class: {
        'active': item.active
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.hours),
        expression: "item.hours"
      }],
      attrs: {
        "type": "number",
        "disabled": !item.active,
        "min": "0",
        "max": "999",
        "placeholder": "0"
      },
      domProps: {
        "value": (item.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "hours", $event.target.value)
        }
      }
    }), _c('label', [_vm._v("ч")])]), _c('div', {
      staticClass: "z-time-input",
      class: {
        'active': item.active
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.minutes),
        expression: "item.minutes"
      }],
      attrs: {
        "type": "number",
        "disabled": !item.active,
        "min": "0",
        "max": "60",
        "placeholder": "0"
      },
      domProps: {
        "value": (item.minutes)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "minutes", $event.target.value)
        }
      }
    }), _c('label', [_vm._v("м")])])]), _c('div', {
      staticClass: "z-time__field title",
      class: {
        'active': item.active
      }
    }, [_vm._v("1д = 8ч = 480м")]), (parseInt(item.user.id) === parseInt(_vm.$props.user.id)) ? _c('div', {
      staticClass: "z-time__field action-bar"
    }, [(!item.active) ? _c('div', {
      staticClass: "z-time__btn",
      on: {
        "click": function($event) {
          _vm.activate(i)
        }
      }
    }, [_c('md-icon', {
      staticClass: "small"
    }, [_vm._v("edit")])], 1) : _vm._e(), (item.active) ? _c('div', {
      staticClass: "z-time__btn",
      on: {
        "click": function($event) {
          _vm.showDeleteDialog(item, i)
        }
      }
    }, [_c('md-icon', {
      staticClass: "small"
    }, [_vm._v("delete")])], 1) : _vm._e(), (item.active) ? _c('div', {
      staticClass: "z-time__btn",
      on: {
        "click": function($event) {
          _vm.saveTime(item, i)
        }
      }
    }, [_c('md-icon', {
      staticClass: "small"
    }, [_vm._v("check")])], 1) : _vm._e(), (item.active) ? _c('div', {
      staticClass: "z-time__btn",
      on: {
        "click": function($event) {
          _vm.deactivate(i)
        }
      }
    }, [_c('md-icon', {
      staticClass: "small"
    }, [_vm._v("close")])], 1) : _vm._e()]) : _vm._e()]), _c('div', {
      staticClass: "z-time__bottom"
    }, [_c('div', {
      staticClass: "z-time__field description",
      class: {
        'active': item.active
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.active),
        expression: "!item.active"
      }],
      staticClass: "z-time__description-content",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.active),
        expression: "item.active"
      }],
      staticClass: "z-time-input",
      class: {
        'active': item.active
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      ref: ('desc-' + i),
      refInFor: true,
      attrs: {
        "minlength": "0",
        "maxlength": "5000"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }, function($event) {
          _vm.resizeTextarea(('desc-' + i))
        }],
        "change": function($event) {
          _vm.resizeTextarea(('desc-' + i))
        },
        "paste": function($event) {
          _vm.resizeTextarea(('desc-' + i))
        }
      }
    })])])])])
  })), _c('div', {
    staticClass: "z-task-time__add-btn",
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', [_vm._v("Добавить")]), _c('md-icon', {
    staticClass: "small"
  }, [_vm._v("add")])], 1)]), _c('md-dialog', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s('Удалить учтёное время' + ((_vm.timeToDelete) ? (' за ' + _vm.moment(_vm.timeToDelete.date).format('DD.MM.YYYY')) : '') + '?'))]), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.hideDeleteDialog()
      }
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.removeTime()
      }
    }
  }, [_vm._v("Удалить")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efbf868c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZTaskTime.vue
// module id = 1277
// module chunks = 0